import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { toast } from 'react-toastify';
import { IUserName } from 'src/interfaces/Users/RegisterInterfaces';
import FormModel from 'src/models/forms/FormModel';
import RegistrationService from 'src/services/User/RegistrationService';
import { useUtilityStore } from 'src/stores/useMobxStores';
import InputDefinitionBuilder from '../../../../utils/inputDefinitions/InputDefinitionBuilder';
import StandardTextBoxField from '../../textbox/StandardTextBoxField';
import { IInputFieldProps } from '../common/IInputFieldProps';
import { EmailFieldErrorMessage } from './EmailFieldErrorMessage';

interface IUsernameField extends IInputFieldProps {
  model: IUserName & FormModel;
}

const UsernameField: React.FC<IUsernameField> = (props: IUsernameField) => {
  const utilityStore = useUtilityStore();
  const [inputDefinition] = React.useState(
    new InputDefinitionBuilder('Username')
      .WithRequiredTextBoxField(true, 'Username is required')
      .WithCustomValidationRule(() => {
        if (utilityStore.validate.username) return 'Username Exists';
      })
      .WithPlaceholder('Username')
      .WithPattern(new RegExp('^[A-Za-z][A-Za-z0-9]*$'), 'Username cannot contain spaces or special characters')
      .Build()
  );
  const onBlur = () => {
    const checkUsername = async () => {
      const registrationService = new RegistrationService();
      const response = await registrationService.checkUsername(props.model.userName);
      if (response.data) {
        utilityStore.validate.username = false;
      } else {
        utilityStore.validate.username = true;
        toast.error(<EmailFieldErrorMessage />, { theme: 'colored', position: 'top-center' });
      }
    };
    checkUsername();
  };

  return (
    <StandardTextBoxField
      name='userName'
      value={props.model.userName}
      onModelChange={props.model.OnModelChange}
      onBlur={onBlur}
      inputDefinition={inputDefinition}
      disabled={props.disabled}
      noStyle={props.noStyle}
    />
  );
};

export default observer(UsernameField);
